import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";

import {Box, Accordion, AccordionDetails, AccordionSummary, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TrainerDetailViewModal from '../../../Components/Modal/TrainerDetailViewModal';
import { getFormatedDate, fancyTimeFormat } from "../../../Js/TimeAndDate";
import { getTrainerUsageData } from "../Services";

const AccordionList = (props) => {

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    // State
    const { trainerReportData, fetchTrainer } = props;

    const [expanded, setExpanded] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const [courseDetailData, setCourseDetailData] = useState([]);
    const [taskDetailData, setTaskDetailData] = useState([]);
    const [assiDetailData, setAssiDetailData] = useState([]);
    const [evalDetailData, setEvalDetailData] = useState([]);


    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const handleTrainerDetail = async (itemdate, actor = null) => {
        console.log("itemdate=====>", itemdate, "actor====>", actor);
        let trainerIds;
        if (actor != null) {
            trainerIds = [actor];
        }

        let params = {
            query: {
                'reportType': 'dateWiseDetailReport',
                'date': itemdate,
                'user_uid': trainerIds,
                'site_uuid': userInfo.site_uuid
            }
        };

        let resTrainerData = await getTrainerUsageData(params);
        console.log("resTrainerData====>", resTrainerData);
        if (resTrainerData.status == 200) {
            setTaskDetailData(resTrainerData.data[0].taskData);
            setAssiDetailData(resTrainerData.data[1].assiData);
            setCourseDetailData(resTrainerData.data[2].courseData);
            setEvalDetailData(resTrainerData.data[3].evalData);
            setModalVisible(true);
        }
    };

    const handleResetData = (flag) => {
        setModalVisible(flag);
        setTaskDetailData([]);
        setAssiDetailData([]);
        setCourseDetailData([]);
        setEvalDetailData([]);
    }

    return (
        <Box>
            {trainerReportData && trainerReportData.length > 0 && (
                <>
                    {trainerReportData.map((objSection, index) => {
                        return (
                            <Accordion
                                expanded={expanded === 'panel' + index}
                                onChange={handleChange('panel' + index)}
                                sx={{ backgroundColor: '#F5F7FF', boxShadow: 0, my: 1 }}
                                key={`accordion_${index}`}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}
                                    aria-controls="panel1bh-content"
                                    id="panel1bh-header"
                                >
                                    <Box sx={{ textAlign: 'left' }}>
                                        <Typography sx={{ color: 'primary.main', fontWeight: '700', fontSize: '1rem', '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>
                                            {fetchTrainer(objSection.actor)}
                                        </Typography>
                                        <Typography sx={{ fontSize: '0.8rem', color: "#A9A9A9", '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                            {fancyTimeFormat(objSection.totalTime) + ' min - ' + objSection.detailData.length + ' Day(s)'}
                                        </Typography>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails >
                                    <TableContainer>
                                        <Table sx={{ minWidth: 400 }} >
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.7rem', fontWeight: '600', padding: '1px', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}>
                                                        Date
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.7rem', fontWeight: '600', padding: '1px', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}>
                                                        Presentation
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.7rem', fontWeight: '600', padding: '1px', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}>
                                                        Task
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.7rem', fontWeight: '600', padding: '1px', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}>
                                                        Assignment
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.7rem', fontWeight: '600', padding: '1px', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}>
                                                        Evaluation
                                                    </TableCell>
                                                    <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.7rem', fontWeight: '600', padding: '1px', '@media (min-width: 1636px)': { fontSize: '1.2rem' } }}>
                                                        Total Time
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {objSection.detailData.map((trainerData, trainerIndex) => {
                                                    return (
                                                        // onClick={() => { handleTrainerDetail(trainerData.date, objSection.actor) }}
                                                        <TableRow key={trainerIndex} sx={{ py: 0 }} >
                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.6rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                                                {getFormatedDate(trainerData.date, 'DD-MMM-YY')}
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.6rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                                                {fancyTimeFormat(trainerData.courseTime) + ' m'}
                                                            </TableCell>
                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.6rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                                                {fancyTimeFormat(trainerData.taskTime) + ' m'}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.6rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                                                {fancyTimeFormat(trainerData.assiTime) + ' m'}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.6rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                                                {fancyTimeFormat(trainerData.evalTime) + ' m'}
                                                            </TableCell>

                                                            <TableCell align="center" sx={{ color: '#DB8829', fontSize: '0.6rem', fontWeight: '500', padding: '10px', '@media (min-width: 1636px)': { fontSize: '1rem' } }}>
                                                                {fancyTimeFormat(trainerData.totalTime) + ' m'}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </AccordionDetails>
                            </Accordion>
                        )
                    }
                    )}
                    {modalVisible &&
                        <TrainerDetailViewModal
                            show={modalVisible}
                            courseDetailData={courseDetailData}
                            taskDetailData={taskDetailData}
                            assiDetailData={assiDetailData}
                            evalDetailData={evalDetailData}
                            toggleModal={(flag) => { handleResetData(flag); }}
                        />
                    }
                </>

            )}
        </Box>
    );
}

export default AccordionList;